import React, { Fragment, useEffect, useState, useRef } from 'react';
import { DataGridPro, GridRowEditStopReasons, GridRowModes, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import '../modals.css';

const DisplayPBSegment = ( { close, aid, uid, pid, segment, user, viewing, canExport, stack, playbooks, contacts, loans, leadopps } ) => {
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ pbName, setPBName ] = useState( '' );
    const [ loading, setLoading ] = useState( true );
    const [ rows, setRows ] = useState( [] );

    let cols = [
        { 
            field: 'name', 
            headerName: 'Contact', 
            width: 350, 
            renderCell: ( params ) => <Link to={`/contact/${params.row.cid}`}>{params.value}</Link>, 
        },
        { 
            field: 'objName', 
            headerName: 'Loan / Lead Opp', 
            flex: 1,
            renderCell: ( params ) => <Link to={`/${params.row.objType}/${params.row.oid}`}>{params.value}</Link>
        }
    ];

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                                <Col>
                                    { 
                                        selectedRows.length > 0 &&
                                        <Row style={ { borderLeft: '1px solid #CCC' } }>
                                            <Col xs='auto' className='pe-2'>Take Action...</Col>
                                            <Col xs='auto' className='ps-0'>
                                                {/* <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Mass Email</Dropdown.Item>
                                                    {
                                                        hasTxting ? (
                                                            <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Mass Txt</Dropdown.Item>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'event' ) }>Add to an Event</Dropdown.Item>
                                                    {
                                                        hasPhoneBurner ? (
                                                            <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </DropdownButton> */}
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xs='auto' className='text-right'>
                            <GridToolbarQuickFilter />
                        </Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        height: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        if ( pid && playbooks ) {
            const p = playbooks[pid];
            if ( p ) {
                setPBName( p.name );
            }
        }
    }, [ pid, playbooks ] );

    useEffect( () => {
        console.log( 'incoming segment: ', segment );
        if ( segment && segment.length ) {
            let list = [];
            segment.forEach( s => {
                const c = contacts[s.cid];
                let objType = '';
                let objName = '';
                let oid = '';

                if ( s.lid ) {
                    const l = loans[s.lid];
                    objType = 'loan';
                    objName = l.name;
                    oid = l.lid + '#' + c.cid;
                } else if ( s.loid ) {
                    const lo = leadopps[s.loid];
                    objType = 'lead-opp';
                    objName = lo.name;
                    oid = lo.loid + '#' + c.cid;
                } else {
                    objType = 'contact';
                    objName = '';
                    oid = c.cid;
                }
                if ( c ) {
                    list.push( {
                        name: c.name,
                        cid: c.cid,
                        objType: objType,
                        objName: objName,
                        oid: oid
                    } );
                }
            } );
            console.log( 'setting rows: ', list );
            setRows( list );
            setLoading( false );
        }
    }, [ segment, contacts, leadopps, loans ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Current Members of {pbName}</Col>
                </Row>
                <Row className='pt-3 pb-2'>
                    <Col style={ { height: '85vh' } }>
                        <DataGridPro
                            apiRef={gridRef}
                            loading={ loading }
                            rows={rows}
                            columns={cols}
                            density='compact'
                            checkboxSelection
                            disableSelectionOnClick
                            slots={ { toolbar: toolbar } }
                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                            getRowId={ ( row ) => row.oid }
                        />
                    </Col>
                </Row>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    playbooks: state.playbooks.byId,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    leadopps: state.leadopps.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( DisplayPBSegment );